<p-dialog [header]="headerName" [modal]="true" [(visible)]="displayReminder" [style]="{ width: '40rem' }"
    (onHide)="closeRemiderModal()">
    <ng-container *ngIf="isAddMode ||isEditMode ">
        <div class="header p-d-flex p-jc-between">
            <h5 class="p-mt-2"> {{ isEditMode ? 'Edit Reminder' : 'Add Reminder' }}</h5>
        </div>
        <div class="card">
            <form [formGroup]="reminderForm" (ngSubmit)="saveOrUpdateReminder()">
                <div class="p-grid p-mt-0">
                    <div class="p-col-12">
                        <label for="date">Select Date</label>
                        <p-calendar 
                            [showWeek]="true" 
                            formControlName="date" 
                            [showTime]="false"
                            class="responsive-calendar" 
                            [inputStyle]="{'width':'100%'}" 
                            [appendTo]="'body'" 
                            [readonlyInput]="true" 
                            [showButtonBar]="true"
                            [minDate]="minDate">
                        </p-calendar>
                        <div class="p-mt-1">
                            <div *ngIf="reminderForm.get('date').touched && reminderForm.get('date').errors?.['required']"
                                class="p-error p-mt-1">
                                Date is required.
                            </div>
                            <div *ngIf="reminderForm.errors?.['pastDate']" class="p-error p-mt-1">
                                Date & Time cannot be in the past.
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Time Selection Row -->
                <div class="p-grid p-mt-0">
                    <div class="p-col-4">
                        <label for="hour">Hour</label>
                        <p-dropdown
                            formControlName="hour"
                            [options]="hourOptions"
                            placeholder="Hour"
                            [style]="{'width':'100%'}"
                            [appendTo]="'body'"
                            optionLabel="label"
                            optionValue="value">
                        </p-dropdown>
                        <div *ngIf="reminderForm.get('hour').touched && reminderForm.get('hour').errors?.['required']"
                            class="p-error p-mt-1">
                            Hour is required.
                        </div>
                    </div>
                    
                    <div class="p-col-4">
                        <label for="minute">Minutes</label>
                        <p-dropdown
                            formControlName="minute"
                            [options]="minuteOptions"
                            placeholder="Minutes"
                            [style]="{'width':'100%'}"
                            [appendTo]="'body'"
                            [editable]="true"
                            optionLabel="label"
                            optionValue="value"
                            (onFilter)="onMinuteInput($event)"
                            (onBlur)="onMinuteBlur()"
                            (keypress)="validateMinuteInput($event)">
                            <ng-template pTemplate="selectedItem">
                                <span>{{reminderForm.get('minute').value.toString().padStart(2, '0')}}</span>
                            </ng-template>
                        </p-dropdown>
                        <div *ngIf="reminderForm.get('minute').touched && reminderForm.get('minute').errors?.['required']"
                            class="p-error p-mt-1">
                            Minutes are required.
                        </div>
                        <div *ngIf="reminderForm.get('minute').touched && 
                            (reminderForm.get('minute').errors?.['min'] || reminderForm.get('minute').errors?.['max'])"
                            class="p-error p-mt-1">
                            Minutes must be between 0 and 59.
                        </div>
                    </div>

                    <div class="p-col-4">
                        <label>Meridiem</label>
                        <p-dropdown
                            formControlName="period"
                            [options]="periodOptions"
                            placeholder="Select Period"
                            [style]="{'width':'100%'}"
                            [appendTo]="'body'"
                            optionLabel="label"
                            optionValue="value">
                        </p-dropdown>
                    </div>
                </div>

                <div class="p-mt-0">
                    <label for="message">Description</label>
                    <textarea rows="5" cols="30" placeholder="Reminder message (optional)" pInputTextarea
                        formControlName="message">
                </textarea>
                </div>
                <div class="p-mt-1">
                <div *ngIf="reminderForm.get('message').touched && reminderForm.get('message').errors?.['initialSpace']"
                    class="p-error p-mt-1">
                    Message cannot start with a space.
                </div>
                <div *ngIf="reminderForm.get('message').touched && reminderForm.get('message').errors?.['maxlength']"
                    class="p-error p-mt-1">
                    Message cannot exceed 500 characters.
                </div>
            </div>
                <div class="p-text-right p-mt-2">
                    <button type="submit" pButton class="p-mr-1" label="{{ isEditMode ? 'Update' : 'Save' }}"
                        ></button>
                    <button type="button" pButton label="Cancel" class="p-button-secondary" (click)="resetForm()"
                        *ngIf="isEditMode"></button>
                    <button type="button" pButton label="Cancel" class="p-button-secondary" (click)="closeAddReminder()"
                        *ngIf="isAddMode"></button>
                </div>
            </form>
        </div>
    </ng-container>
    <div class="header p-d-flex p-jc-between">
        <h5 class="p-mt-2">Reminder Lists</h5>
        <p-button *ngIf="!isAddMode" label="New Reminder" (onClick)="addNewReminder()"></p-button>
    </div>
    <div class="p-d-flex p-jc-end p-mt-2 p-mb-2">
        <p-dropdown [options]="filterOptions" [(ngModel)]="filterOption" (onChange)="onFilterChange($event.value)"
            placeholder="Select Filter" optionLabel="label" optionValue="value"
            [style]="{ 'min-width': '200px' }" [appendTo]="'body'"></p-dropdown>
    </div>
    <div class="card" *ngIf="reminders?.length > 0">
        <div class="reminder" *ngFor="let reminder of reminders;let index = index;">
            <div class="p-d-flex p-jc-between">
                <div class="p-d-flex p-ai-center">
                    <h6 class="p-mb-0 p-mr-2">{{ index + 1 }}.</h6>
                    <h6 class="p-mb-0">{{ reminder?.date | localDate: 'dateTime' }}</h6>                    
                    <!-- Status Tag -->
                    <p-tag 
                    severity="warning" 
                    value="Ignored" 
                    *ngIf="reminder?.statusId == reminderStatus.Ignored " 
                    class="p-ml-2"
                  ></p-tag>
                  <p-tag 
                    severity="success" 
                    value="Completed" 
                    *ngIf="reminder?.statusId == reminderStatus.Completed" 
                    class="p-ml-2"
                  ></p-tag>
                  </div>
                    <div class="p-d-flex"
                    *ngIf="reminder?.allowEdit">
                <!-- Complete Button -->
                    <span class="btnBars" *ngIf="reminder?.statusId !== reminderStatus.Completed || reminder?.statusId !== reminderStatus.Ignored && reminder?.statusId === reminderStatus.Pending">
                        <i class="pi pi-check"
                        (click)="updateWorkbookReminderStatus(reminder, reminderStatus.Completed)"
                        pTooltip="Complete" tooltipPosition="top"></i>
                    </span>
                    
                    <!-- Ignore Button -->
                    <span class="btnBars" *ngIf="reminder?.statusId !== reminderStatus.Ignored && reminder?.statusId !== reminderStatus.Completed && reminder?.statusId === reminderStatus.Pending">
                        <i class="pi pi-times"
                        (click)="updateWorkbookReminderStatus(reminder, reminderStatus.Ignored)"
                        pTooltip="Ignore" tooltipPosition="top"></i>
                    </span>
  
                    <span class="btnBars">
                        <i class="pi pi-pencil" (click)="openEditReminder(reminder)" pTooltip="Edit Reminder"
                            tooltipPosition="top"></i>
                    </span>
                    <span class="btnBars">
                        <i class="pi pi-trash" (click)="deleteWorkbookReminder(reminder)" pTooltip="Delete Reminder"
                            tooltipPosition="top"></i>
                    </span>
                </div>
            </div>
            <p class="p-ml-4">{{reminder?.message}}</p>
            <hr>
        </div>
        <!-- <p-paginator 
            [rows]="rowsPerPage" 
            [totalRecords]="reminders?.length" 
            [rowsPerPageOptions]="[2, 5, 10, 20]"
            currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
            [showCurrentPageReport]="true" [(first)]="first" (onPageChange)="updatePaginatedReminders($event)"
            >
        </p-paginator> -->
    </div>
    <div class="card p-d-flex p-jc-center p-ai-center" *ngIf="reminders.length == 0" style="height: 100px;">
        <p>No reminder recorded.</p>
    </div>
</p-dialog>
<p-confirmDialog key="reminderdialog" [style]="{ width: '20vw' }" [baseZIndex]="1000000"></p-confirmDialog>